<template>
  <div
    v-editable="blok"
    :style="{ marginLeft: `${blok.margin_left}px` }"
    class="simple-text"
  >
    <img
      v-if="blok.icon && blok.icon.filename"
      :src="blok.icon.filename"
      :alt="blok.icon.alt"
      loading="lazy"
      class="simple-text__icon"
    />
    <p class="paragraph paragraph-long simple-text__text">
      {{ blok.text }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import type { SbTextWithIconStoryblok } from '@/types'
interface Props {
  blok: SbTextWithIconStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.simple-text {
  display: flex;
  align-items: flex-start;

  &__text {
    padding-top: 11px;
    padding-bottom: 11px;
    margin-bottom: 0;
  }

  &__icon {
    width: 18px;
    margin-right: 10px;
    margin-top: 16px;
  }
}
</style>
